export default  {
	bindings: {
		closable: '<'
	},
	controller: 'messageController',
  template: require('../views/message.html')
};



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/base/components/message.component.js